<ng-container>
    <div class="info-slider w-240 h-305 overflow-hidden relative bottom-2">
        <div class="w-240 h-243 sm:bg-contain md:bg-contain mb-12" *ngIf="loginResponse?.disableLoginPageCards" [ngClass]="actualImage"></div>
        <ngx-hm-carousel
            *ngIf="!loginResponse?.disableLoginPageCards && assets && assets.length"
            [(ngModel)]="currentIndex"
            [autoplay]="autoplay"
            [infinite]="infinite"
            [autoplay-speed]="slideInterval"
            [between-delay]="2000"
            class="carousel c-accent">

            <section ngx-hm-carousel-container class="content">
                <article class="item flex flex-row cursor-pointer text-center justify-center m-auto"
                        ngx-hm-carousel-item
                        *ngFor="let asset of assets; let i = index"
                        (click)="navigateToLink(asset?.url)">
                        <div>
                            <div class="w-240 h-243 sm:bg-contain md:bg-contain mb-12">
                                <img [src]="getImageSrc(asset)" alt="" class="w-240 h-243" />
                            </div>
                            <h4 class="font-semibold text-10gpx text-text-default font-body-semibold opacity-90">
                                {{asset.title}}
                            </h4>
                            <div class="font-semibold text-6gpx text-notice font-body-semibold opacity-90">
                                {{asset?.text}}
                            </div>
                        </div>
                    </article>
            </section>
            <ng-template #carouselDot let-model>
                <div class="ball bg-accent border-std-blue border rounded-full w-0.3 h-0.3 mr-0.1 mt-5"
                     [class.visible]="model.index === model.currentIndex"></div>
            </ng-template>
        </ngx-hm-carousel>

    </div>
</ng-container>
